/**
 * Sumber shader WebGL, dirakit dari string GLSL di `shaders/` (GLSL tidak punya
 * `#include`, jadi NOISE_GLSL disisipkan ke liquid-glass lewat penanda
 * `//__NOISE__`). GLSL dipisah dari file ini supaya satu string panjang tidak
 * membengkakkan satu file, dan ditulis sebagai modul TS (bukan `.glsl?raw`)
 * karena build produksi memakai `bun build`, yang tidak mengenal `?raw`.
 * Vertex shader (segitiga layar penuh) dipakai bersama oleh semua jenis.
 */
import { LIQUID_GLASS_FRAG_TEMPLATE } from "./shaders/liquid-glass.frag";
import { LIQUID_GLASS_VERT } from "./shaders/liquid-glass.vert";
import { LIQUID_MORPH_FRAG } from "./shaders/liquid-morph.frag";
import { NOISE_GLSL } from "./shaders/noise";

const NOISE_PLACEHOLDER = "//__NOISE__";

if (!LIQUID_GLASS_FRAG_TEMPLATE.includes(NOISE_PLACEHOLDER)) {
	throw new Error(
		`liquid-glass.frag tidak punya penanda ${NOISE_PLACEHOLDER} — noise tidak tersisip`,
	);
}

export const LIQUID_GLASS_VERTEX_SRC = LIQUID_GLASS_VERT;
export const LIQUID_GLASS_FRAGMENT_SRC = LIQUID_GLASS_FRAG_TEMPLATE.replace(
	NOISE_PLACEHOLDER,
	NOISE_GLSL,
);
export const LIQUID_MORPH_FRAGMENT_SRC = LIQUID_MORPH_FRAG;
